<script setup>
const props = defineProps({
  data: Object
})
const { altFallback } = usePageAltFallback();
const getCardImageAlt = (card) =>
  resolveMediaAlt(card?.image, altFallback.value, 'Image');
</script>

<template>
  <div class="block image-expander">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-4" v-for="(card, index) in props.data.cards" :key="index">
          <!-- Card to show -->
          <NuxtLink data-bs-toggle="modal" :data-bs-target="'#expander-' + index"
            class="card-container with-link">
            <div class="card-image-container">
              <NuxtImg
                :src="card?.image?.url || 'https://via.placeholder.com/640x640'"
                :alt="getCardImageAlt(card)"
                loading="lazy"
                decoding="async"
                format="webp"
                class="card-image"
              ></NuxtImg>
            </div>
            <b class="card-title">
              <div class="title-container">
                <span class="title-text" v-html="card.title"></span><span class="title-caret">></span>
              </div>
            </b>
          </NuxtLink>
          
          <!-- Card modal information -->
          <UIModal :modalId="'expander-' + index" modalClass="modal-dialog-scrollable">
            <div class="card-expander-modal-container">
              <NuxtImg
                :src="card?.image?.url || 'https://via.placeholder.com/640x640'"
                class="card-image"
                :alt="getCardImageAlt(card)"
                loading="lazy"
                decoding="async"
                format="webp"
              />
              <article v-html="card.content"></article>
            </div>
          </UIModal>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.image-expander {
  .card-container {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    text-decoration: none;
    color: $color-body-text;
    overflow: hidden;
    border-radius: 24px;
    border: solid 1px $color-light-gray;
    height: 275px;
    max-width: 100%;
    transition: 0.3s;
    background: $color-secondary no-repeat center center;
    margin: 0 auto 20px;

    .card-image-container{
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      overflow: hidden;
      
      .card-image{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: auto;
        height: 100%;
        transition: 0.3s;
      }
    }

    .card-title {
      position: relative;
      z-index: 1;
      display: block;
      width: 100%;
      height: 75%;
      font-size: 24px;
      color: $color-secondary;
      font-weight: bold;
      text-align: center;
      padding-bottom: 18px;
      padding-top: 50px;
      background: rgb(0,0,0);
      background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(3, 3, 3, 0.67) 24%, rgba(84, 84, 84, 0) 50%);
      .title-container{
        position: absolute;
        width: 100%;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);

        .title-text{

        }
        .title-caret{
          transition: 0.3s;
          margin-left: 5px;
          display: inline-block;
        }
      }
    }

    &.with-link:hover {
      -webkit-box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.16);
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.16);

      .title-caret {
        margin-left: 15px;
      }

      .card-image-container{
        .card-image{
          width: auto;
          height: 125%;
        }
      }
    }
  }

  .card-expander-modal-container{
    .card-image{
      display: block;
      margin: 0 auto 20px;
      max-width: 100%;
      width: 100%;
    }
  }
}

</style>